import memoize from 'lodash-es/memoize';
import { StrollersItem, StrollersItemPlaceholder } from 'mk2/apps/strollers/components/StrollersItem';
import { StrollerEntity } from 'mk2/apps/strollers/schemas';
import InfiniteList from 'mk2/components/InfiniteListLoadable';
import NoResults from 'mk2/components/NoResults';
import LoadingSwitch from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { LoadingState } from 'mk2/reducers/loadingState';
import React from 'react';
import styles from './StrollersList.mscss';

const ROW_HEIGHT = 130;

interface OwnProps {
    items: StrollerEntity[];
    hasMore: boolean;
    loadingState: LoadingState;
    wishlist: any;
    noResultMessage: string;

    load();
    loadNext();
    onWishlistToggle(strollerId);
}

export class StrollersList extends React.Component<OwnProps> {

    public static defaultProps: Partial<OwnProps> = {
    };

    private onWishlistToggle = memoize((id) => (event) => {
        event.preventDefault();
        this.props.onWishlistToggle(id);
    });

    // TODO: ListItemPlaceholder - make it look more like a stroller item
    public render() {
        const { items, load, loadingState } = this.props;
        const strollers = (typeof items !== 'undefined') ? items : [];

        return (
            <div className={styles.StrollersList}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={load}
                    onRenderInit={this.renderInit}
                    onRenderSuccess={this.renderLoadSuccess}
                    hasData={strollers && strollers.length > 0}
                />
            </div>
        );
    }

    private renderInit = () => {
        return (
            <div className={styles.StrollersList__items}>
                <StrollersItemPlaceholder />
                <StrollersItemPlaceholder />
                <StrollersItemPlaceholder />
                <StrollersItemPlaceholder />
                <StrollersItemPlaceholder />
                <StrollersItemPlaceholder />
            </div>
        );
    };

    private renderLoadSuccess = () => {
        const { hasMore, items, loadNext, noResultMessage } = this.props;
        const strollers = (typeof items !== 'undefined') ? items : [];
        const rowCount = hasMore ? strollers.length + 1 : strollers.length;

        return (items.length > 0) ? (
            <div className={styles.StrollersList__items}>
                <InfiniteList
                    isRowLoaded={this.isRowLoaded}
                    loadMoreRows={loadNext}
                    rowCount={rowCount}
                    rowHeight={ROW_HEIGHT}
                    rowRenderer={(props) => this.rowRenderer(props) /* tslint:disable-line */}
                />
            </div>
        ) : (
            <NoResults message={noResultMessage} noIcon />
        );
    };

    private isRowLoaded = ({ index }) => !this.props.hasMore || index < this.props.items.length;

    private rowRenderer = ({ index, key, style }) => {
        const { items, wishlist } = this.props;

        if (!this.isRowLoaded({ index })) {
            return (
                <StrollersItemPlaceholder key={key} style={{ ...style, height: 130 }} />
            );
        }

        const item = items[index];

        return (
            <StrollersItem
                stroller={item}
                key={key}
                style={style}
                isInWishList={(wishlist.indexOf(item.id.toString()) > -1)}
                onWishlistToggleClick={this.onWishlistToggle(item.id)}
            />
        );
    };
}
